<template>
    <v-select v-model="selectedFiscalite" :items="$store.state.products.fiscalites" :loading="isLoading" :disabled="disabled" item-value="key" :clear-icon="'far fa-times-circle'" :menu-props="{ bottom: true, offsetY: true }" @change="$emit('input', selectedFiscalite)" :multiple="multiple" :label="label" :placeholder="placeholder" background-color="white" hide-details no-filter outlined clearable dense>
        <template v-slot:selection="data">
            <v-chip v-if="data.index === 0" color="accent" small label dark>
                {{ data.item.label }}
            </v-chip>

            <span v-if="data.index === 1" class="grey--text text-caption">
                (+{{ selectedFiscalite.length - 1 }} autres)
            </span>
        </template>

        <template v-slot:item="{ item }">
            <v-list-item-content>
                <v-list-item-title>
                    <v-chip color="accent" label small dark>
                        {{ item.label }}
                    </v-chip>
                </v-list-item-title>
            </v-list-item-content>
        </template>
    </v-select>
</template>

<script>
import productsMixin from '../../mixins/products.js';

export default {
    name: 'ProgramFiscaliteSelect',

    mixins: [productsMixin],

    props: {
        value: { required: true },
        label: { type: String },
        placeholder: { type: String },
        disabled: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false }
    },

    data: () => ({
        selectedFiscalite: null,
        isLoading: false,
        items: []
    }),

    created() {
        this.selectedFiscalite = this.value;
    }
};
</script>